module.exports = __webpack_public_path__ + "static/media/delete.599d3aaa.svg";